import { Breadcrumbs, Button, Div, NavigationHeader } from '@driftt/tide-core'
import { BreadcrumbsHeadingProps } from '@driftt/tide-core'
import { showTransientNotification } from '@driftt/traffic-control'
import { pathOr } from 'ramda'
import React, { useState } from 'react'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'

import { saveGlobalPriorities } from 'api/playbooks'
import PlaybookPriorityTable, {
  PriorityPayload,
} from 'components/PlaybookPriorityTable'

import styles from './styles.module.css'

const breadcrumbsTemplate = (
  typeDisplayName: string,
  typePathName: string
): BreadcrumbsHeadingProps[] => {
  return [
    {
      title: 'Playbooks',
      link: '/playbooks',
    },
    {
      title: typeDisplayName,
      link: `/playbooks/list/${typePathName}`,
    },
    {
      title: `Set priority`,
      link: '/',
      isActive: true,
    },
  ]
}

const typeToBreadcrumbs = {
  chat: breadcrumbsTemplate('Chat', 'chat'),
  meetings: breadcrumbsTemplate('Meeting', 'meetings'),
}

const PlaybookPriorityLayout = ({ history, match }: RouteComponentProps) => {
  const [priorityPayload, setPriorityPayload] = useState<PriorityPayload>({
    idPriorityList: [],
    playbookTypes: { ABM: [], nonSpecial: [], outbound: [] },
  })
  const [hasPriorityChanged, setHasPriorityChanged] = useState(false)
  const dispatch = useDispatch()

  const typeInPath = pathOr('chat', ['params', 'type'], match)
  const type =
    (Object.keys(typeToBreadcrumbs) as (keyof typeof typeToBreadcrumbs)[]).find(
      (t) => t === typeInPath.toLowerCase()
    ) || 'chat'
  const headings = typeToBreadcrumbs[type]

  const { mutate: saveGlobalPrioritiesMutation, isLoading: isSaving } =
    useMutation({
      //TODO: Fix type collition between react query and SWR
      //@ts-ignore
      mutationKey: 'save-playbooks-priority',
      mutationFn: (params: { idPriorityList: number[]; type: string }) =>
        saveGlobalPriorities(params.idPriorityList, { type: params.type }),
      onSuccess: () => {
        history.push('/playbooks')
        dispatch(
          showTransientNotification({
            message: 'Playbook priority has been successfully updated!',
            type: 'success',
          })
        )
      },
    })

  const onSave = () => {
    saveGlobalPrioritiesMutation({
      idPriorityList: priorityPayload.idPriorityList,
      type,
    })
  }

  return (
    <Div className={styles.playbookPriorityPageContainer}>
      <NavigationHeader
        title="Set priority"
        secondary={<Breadcrumbs headings={headings} />}
      >
        <Div>
          <Button
            type="tertiary"
            className={styles.playbookPriorityCancelButton}
            onClick={() => history.goBack()}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            loading={isSaving}
            disabled={!hasPriorityChanged}
          >
            Save changes
          </Button>
        </Div>
      </NavigationHeader>
      <Div className={styles.playbookPriorityTableContainer}>
        <PlaybookPriorityTable
          priorityPayload={priorityPayload}
          setPriorityPayload={setPriorityPayload}
          setHasPriorityChanged={setHasPriorityChanged}
          showWorkspaces={true}
          type={type}
        />
      </Div>
    </Div>
  )
}

export default PlaybookPriorityLayout
